'use client';

import { c as _c } from "react/compiler-runtime";
import type { RoundupDriverGroupEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import type { AnalyticsMarketplacePayload } from '@cc-shopping/platform-analytics/types';
import type { GridProps } from '@mui/material';
import { useApprovalLikelihoodContext } from 'src/features/approval-odds/context';
import { getCardsApprovalOddsDriver } from 'src/features/approval-odds/getCardsApprovalOddsDriver';
import { useApprovalOddsLikelihood } from 'src/features/approval-odds/useApprovalOddsLikelihood';
import type { ComponentDriver } from '../types';
import { Driver } from './Driver';
export function ApprovalOddsDriver(t0) {
  const $ = _c(16);
  const {
    approvalLikelihood,
    creditScore,
    productId,
    isInstitutionAmex,
    marketplacePayload,
    driverGroup,
    itemProps,
    segmentActionSection
  } = t0;
  let t1;
  if ($[0] !== marketplacePayload.section_name || $[1] !== marketplacePayload.section_position) {
    t1 = {
      sectionName: marketplacePayload.section_name,
      sectionPosition: marketplacePayload.section_position
    };
    $[0] = marketplacePayload.section_name;
    $[1] = marketplacePayload.section_position;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    label: approvalOddsLabel,
    value: approvalOddsValue
  } = useApprovalOddsLikelihood(t1, creditScore, isInstitutionAmex, approvalLikelihood);
  const {
    approvalLikelihoods,
    isLoading
  } = useApprovalLikelihoodContext();
  const approvalOdds = approvalLikelihoods ? approvalLikelihoods[productId ?? ""] : undefined;
  let t2;
  if ($[3] !== approvalOddsLabel || $[4] !== approvalOddsValue) {
    t2 = {
      id: "recommendedCreditScore",
      label: approvalOddsLabel,
      value: approvalOddsValue
    };
    $[3] = approvalOddsLabel;
    $[4] = approvalOddsValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let driver = t2;
  if (approvalOdds) {
    let t3;
    if ($[6] !== approvalOdds.approvalLikelihood || $[7] !== isLoading) {
      t3 = getCardsApprovalOddsDriver(approvalOdds.approvalLikelihood, isLoading);
      $[6] = approvalOdds.approvalLikelihood;
      $[7] = isLoading;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    const approvalDriver = t3;
    let t4;
    if ($[9] !== approvalDriver) {
      t4 = {
        id: "recommendedCreditScore",
        ...approvalDriver
      };
      $[9] = approvalDriver;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    driver = t4;
  }
  let t3;
  if ($[11] !== driver || $[12] !== driverGroup || $[13] !== itemProps || $[14] !== segmentActionSection) {
    t3 = <Driver driver={driver} driverGroup={driverGroup} itemProps={itemProps} segmentActionSection={segmentActionSection} />;
    $[11] = driver;
    $[12] = driverGroup;
    $[13] = itemProps;
    $[14] = segmentActionSection;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}